import React from 'react';
import ReactDOM from 'react-dom';
import './PatentDetail.css';
import ImageCarousel from './ImageCarousel';

const formatDate = (yyyymmdd) => {
  if (!yyyymmdd || yyyymmdd.length < 8) return yyyymmdd || '';
  return `${yyyymmdd.slice(6, 8)}/${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(0, 4)}`;
};

const ScoreBar = ({ label, value }) => {
  if (value === undefined || value === null) return null;
  return (
    <div className="patent-score">
      <span className="patent-score-label">{label}</span>
      <div className="patent-score-bar-track">
        <div className="patent-score-bar-fill" style={{ width: `${value * 10}%` }} />
      </div>
      <span className="patent-score-value">{value}/10</span>
    </div>
  );
};

const PatentDetail = ({ patent, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!patent) return null;

  const title = patent.title_en || patent.title || '';
  const applicants = Array.isArray(patent.applicants) ? patent.applicants : [];

  const images = [
    patent.preview_image,
    ...(Array.isArray(patent.preview_images) ? patent.preview_images : [])
  ].filter(Boolean);

  const hasScores = patent.novelty != null || patent.disruption != null || patent.industrialization != null;

  const modalContent = (
    <div className="patent-detail-overlay" onClick={handleOverlayClick}>
      <div className="patent-detail-container">
        <div className="patent-detail-header">
          <h2>{title}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="patent-detail-content">
          {/* Image Carousel */}
          {images.length > 0 && (
            <ImageCarousel images={images} isLocked={false} />
          )}

          {/* Metadata */}
          <div className="patent-section patent-meta-section">
            {applicants.length > 0 && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Applicant{applicants.length > 1 ? 's' : ''}</span>
                <span className="patent-meta-val">{applicants.join(', ')}</span>
              </div>
            )}
            {patent.publication_date && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Publication date</span>
                <span className="patent-meta-val">{formatDate(patent.publication_date)}</span>
              </div>
            )}
            {patent.patent_number && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Patent number</span>
                {patent.patent_url ? (
                  <a className="patent-meta-val patent-link" href={patent.patent_url} target="_blank" rel="noopener noreferrer">
                    {patent.patent_number}
                  </a>
                ) : (
                  <span className="patent-meta-val">{patent.patent_number}</span>
                )}
              </div>
            )}
            {patent.category && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Category</span>
                <span className="patent-meta-val">{patent.category}</span>
              </div>
            )}
            {patent.subsystem && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Subsystem</span>
                <span className="patent-meta-val">{patent.subsystem}</span>
              </div>
            )}
            {patent.part && (
              <div className="patent-meta-row">
                <span className="patent-meta-key">Part</span>
                <span className="patent-meta-val">{patent.part}</span>
              </div>
            )}
          </div>

          {/* Scores */}
          {hasScores && (
            <div className="patent-section">
              <h3>Scores</h3>
              <ScoreBar label="Novelty" value={patent.novelty} />
              <ScoreBar label="Disruption" value={patent.disruption} />
              <ScoreBar label="Industrialization" value={patent.industrialization} />
            </div>
          )}

          {/* Summary */}
          {patent.summary && (
            <div className="patent-section">
              <h3>Summary</h3>
              <p className="patent-text">{patent.summary}</p>
            </div>
          )}

          {/* Implication */}
          {patent.implication && (
            <div className="patent-section">
              <h3>Implication</h3>
              <p className="patent-text">{patent.implication}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default PatentDetail;
